<template>
  <a-modal
    title="Confirmation"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    :confirm-loading="confirmLoading"
    @cancel="handleCancel"
    cancelText= 'Cancel'
  >
    <a-alert
      message="Exceeded limit Value"
      :description="'Your report has exceeded the limit of ' + limitasi"
      type="error"
      closable
      v-if="errorText"
      @close="alertClose"
    />
    <a-form :form="formEdit">
      <a-form-item label="No UM PD">
        <a-select
          showSearch
          placeholder="UM Detail"
          class="select-between c_noumpd"
          v-decorator="[
            'um_detail',
            { rules: [{ required: true }], initialValue: data.selected_um },
          ]"
          option-filter-prop="children"
            :filter-option="filterOption"
          @change="handleChangeumDtl"
        >
          <a-select-option v-for="item in data.list_um" :key="item.id_um_dtl">
            <div class="select-option">
              <div v-if="!getScreen">
                <h4>{{ item.item_nm }}</h4>
              </div>
              <h4 v-else>{{ item.item_nm }}</h4>
              <small>{{
                formatRupiah(item.saldo_um)
                  .replace("Rp", "")
                  .replace(",00", "")
              }}</small>
            </div>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Description">
        <a-input
          v-decorator="[
            'deskripsi',
            { rules: [{ required: true }], initialValue: data.deskripsi },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Usage Date">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="[
            'tanggal_pemakaian',
            {
              rules: [{ required: true }],
              initialValue: data.tanggal_pemakaian,
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="Credit">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="
            (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
          v-decorator="[
            'kredit',
            {
              rules: [{ required: true }, { validator: checkPrice }],
              initialValue: data.kredit,
            },
          ]"
        />
      </a-form-item>
      <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: data.iscommision },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: data.without_note },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
          >
          <!-- :remove="handledoctransRemove" -->
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import axios from "axios";
import _ from "lodash";

export default {
  props: {
    //confirmLoading: Boolean,
    modalEdit: Boolean,
    data: {},
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getAuth",
      "getScreen",
      "getStandartFormatDate",
    ]),
  },
  data() {
    return {
      errorText: false,
      confirmLoading: false,
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
    };
  },
  beforeCreate() {
    this.formEdit = this.$form.createForm(this);
  },
  watch:{
    data(){
      if(this.data.id){
        this.EnCommission = this.data.EnCommission;
        this.Viwithout_note = this.data.Viwithout_note;
        this.doctransfiles = this.data.doctransfiles;
      }
    }
  },
  methods: {
    moment,
    alertClose() {
      this.errorText = false;
    },
    handleCancel(e) {
      Event.$emit("modalCancel", false);
      this.formEdit.resetFields();
      this.errorText = false;
    },
    handleModalEditOk() {
      this.formEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }
        
        let url =
          this.data.type === "revised"
            ? "lap_um_pd/revisi_detil_pemakaian_edit"
            : "lap_um_pd/detil_pemakaian_edit";

        let addData = new FormData();
        addData.append("id", this.data.id);
        addData.append("id_lk_draft", this.data.id);
        addData.append("tanggal_pemakaian", moment(
            values.tanggal_pemakaian
          ).format(this.getStandartFormatDate));
        addData.append("um_dtl", values.um_detail);
        addData.append("deskripsi", values.deskripsi);
        addData.append("kredit", values.kredit);
        addData.append("iscommision", values.iscommision);
        // addData.append("without_note", values.without_note);
        addData.append("without_note", "1");

        if (this.doctransfiles && this.doctransfiles.length > 0) {
          this.doctransfiles.forEach((file) => {
            addData.append("file_upload", file);
          });
        }

        this.confirmLoading = true;
        this.$store
          .dispatch("putLapDetil", {
            auth: this.getAuth,
            params: { data: addData, url: url },
          })
          .then((res) => {
            Event.$emit("fetchDetilUm");
            this.formEdit.resetFields();
            this.errorText = false;
            Event.$emit("modalCancel", false);
            this.confirmLoading = false;
          })
          .catch((err) => {
            console.log(err.response);
            this.confirmLoading = false;
            this.displayMessageValue("error-other", err.response.data.message);
          });
      });

      // this.formEdit.validateFields((err, values) => {
      //   if (err) {
      //     this.displayMessage("form-warning");
      //     return;
      //   }
      //   const counting_value =
      //     this.data.totalKreditSebelum - this.data.kredit + values.kredit;
      //   const limitasi = this.data.debit + this.data.limitasi;
      //   if (counting_value > limitasi) {
      //     this.errorText = true;
      //     this.limitasi = limitasi;
      //     return;
      //   } else {
      //     this.confirmLoading = true;
      //     let url =
      //       this.data.type === "revised"
      //         ? "lap_um_pd/revisi_detil_pemakaian"
      //         : "lap_um_pd/detil_pemakaian";
      //     axios({
      //       method: "put",
      //       url: this.$serviceUrl + url,
      //       processData: false,
      //       data: {
      //         id: this.data.id,
      //         tanggal_pemakaian: values.tanggal_pemakaian.format("YYYY-MM-DD"),
      //         deskripsi: values.deskripsi,
      //         kredit: values.kredit,
      //       },
      //       auth: {
      //         username: this.getAuth.username,
      //         password: this.getAuth.password,
      //       },
      //       headers: {
      //         "Content-Type": "application/json",
      //         "X-API-KEY": this.getAuth.apikey,
      //       },
      //     })
      //       .then((response) => {
      //         this.confirmLoading = false;
      //         this.formEdit.resetFields();
      //         Event.$emit("modalCancel", false);
      //         Event.$emit("fetchPemakaian", true);
      //         this.errorText = false;
      //       })
      //       .catch((err) => {
      //         let responses = Object.assign({}, err.response.data);
      //         this.displayMessageValue("error-other", responses.message);
      //         this.confirmLoading = false;
      //         console.log("error : " + err);
      //       });
      //   }
      // });
    },
    checkPrice(rule, value, callback) {
      if (value >= 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEdit.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.data.list_um, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
};
</script>

<style lang="less">
.c_noumpd{
  .ant-select-selection__rendered{
    overflow: auto;
  }
}
</style>
